<script setup>
import { onMounted, onUnmounted, ref, computed } from 'vue'

import moment from 'moment'

import { pagePrint } from '@utils'
import Main from '../layout/Main.vue'
import { Button, Icon } from '@components'
import ConfirmationLoader from './ConfirmationLoader.vue'
import ConfirmationInformation from './ConfirmationInformation.vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()


const addToCalendar = () => {
    let confirmation = $appointments.confirmation

    let staff_name = confirmation.meta?.staff_name
    let service_name = confirmation.meta?.service_name
    let business_name = $settings.business.name
    let text = staff_name ? `${business_name} - ${service_name} with ${staff_name}` : `${business_name} - ${service_name}`
    let date = confirmation.booking_date.split(' ')[0]
    let dateTime = {
        start: moment(`${date}T${confirmation.booking_time_start}`).format('YYYYMMDDTHHmmss[Z]'),
        end: moment(`${date}T${confirmation.booking_time_end}`).format('YYYYMMDDTHHmmss[Z]'),
        // 20240105T160000Z
    }
    let details = `Thanks for choosing ${business_name}. We will be in touch with you shortly.`
    let location = confirmation.meta?.address

    window.open(`https://calendar.google.com/calendar/u/0/r/eventedit?text=${text}&dates=${dateTime.start}/${dateTime.end}&details=${details}&location=${location}&sf=true&output=xml&pli=1`)
}

onUnmounted(() => {
    localStorage.removeItem('prebook_stripe_confirmation_data')

    $appointments.appointment.value = {
        service_id: null,
        staff_id: null,
        booking_date: null,
        booking_time_start: null,
        payment_method: $prebook.value.settings.payment.default_payment_method || 'cash',
        booking_time_end: null,
    }

    $appointments.cookiesAppointment('set')
})

const buttonStyle = computed(() => {
    // return `font-weight:${getFontWeight($settings.customizer.design.button_text_font_weight)} !important; color:${$settings.customizer.design.button_text_font_color} !important; border-radius:${$settings.customizer.design.button_border_radius}px !important; border: 1px solid ${$settings.customizer.design.button_background_color} !important; background-color:${$settings.customizer.design.button_background_style == 'Filled' ? $settings.customizer.design.button_background_color : 'transparent'} !important;`
    return `border-radius:${$settings.customizer.design.button_border_radius}px !important;`
})
</script>

<template>
    <Main :sideNav="false" width="650px" height="100%" rightContentClass="w-full">
        <template #content>

            <!-- confirmation loader -->
            <ConfirmationLoader v-if="!$appointments.isConfirmationLoaded" />

            <!-- confirmation information -->
            <ConfirmationInformation v-if="$appointments.isConfirmationLoaded" />

        </template>
        <template #footer v-if="$appointments.isConfirmationLoaded">
            <div class="grid grid-cols-2 gap-5">
                <Button @click="pagePrint('print-frontend-confirmation')" type="secondary_gray" size="sm" radius="square" class="w-full" :buttonStyle="buttonStyle">
                    <Icon name="printer" size="20px" />
                    Print
                </Button>
                <Button @click="addToCalendar()" type="secondary_gray" size="sm" radius="square" class="w-full" :buttonStyle="buttonStyle">
                    <Icon name="calendar" size="20px" />
                    Add to calendar
                </Button>
            </div>
        </template>
    </Main>
</template>